import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

const DOC = gql`
  mutation GenerateSpaceReportFile(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $reportId: SpaceReportId!
    $configuration: SpaceReportConfigurationInput!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                generateSpaceReportFile(
                  id: $reportId
                  configuration: $configuration
                )
              }
            }
          }
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.GenerateSpaceReportFileMutation,
  void,
  graphql.schema.GenerateSpaceReportFileMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
